export default "__VITE_ASSET__8WxO1qid__"